module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3fCXa"))).then(() => parcelRequire('hEqeo'));